import { _RULES } from "@/store/_RULES";
import { _GROUPS } from "@/store/_PERMISSIONS";

// -- FIELDS
const _FIELDS = [
  {
    label: "Utilizador",
    name: "id_utilizador",
    type: "array",
    store: "utilizador",
    size: {
      cols: 12,
      sm: 12,
      md: 12
    },
    rules: [_RULES.required]
  },
  {
    title: "Data adesão",
    type: "data",
    name: "data",
    size: {
      cols: 6,
      sm: 6,
      md: 6
    },
    rules: [_RULES.required],
  },
  {
    label: "Ano início",
    name: "ano_inicio",
    type: "text",
    size: {
      cols: 6,
      sm: 6,
      md: 6
    },
    rules: [_RULES.required, _RULES.isNumber]
  },
];

// -- HEADERS
const _HEADERS = [
  {
    text: "Utilizador",
    align: "left",
    value: "utilizador"
  },
  {
    text: "Data adesão",
    align: "left",
    value: "data"
  },
  {
    text: "Ano de início",
    align: "left",
    value: "ano_inicio"
  },
  {
    text: "Ações",
    value: "action"
  }
];

const ASSOCIADO = {
  _FIELDS: _FIELDS,
  _HEADERS: _HEADERS
};

export default ASSOCIADO;
